module.exports = "<tickets-page></tickets-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/tickets.html
// module id = 1599
// module chunks = 0